/* unplugin-vue-components disabled */import { render } from "./PosterAppShare.vue?vue&type=template&id=b8411dac"
import script from "./PosterAppShare.vue?vue&type=script&lang=js"
export * from "./PosterAppShare.vue?vue&type=script&lang=js"

import "./PosterAppShare.vue?vue&type=style&index=0&id=b8411dac&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__